
import React from 'react'

import { composeClassName } from '../../utils/common'

import AvatarImage from '../../utils/AvatarImage'
import { MessageProps } from '../../../MessageDisplayArea'

const TypingMessage: React.FC<MessageProps> = ({
  message: {
    text,
    nickname,
    isLastInGroup,
    isFirstInGroup,
  },
  renderParams: {
    imgParams,
  },
  common: {
    messageViewType,
  }
}) => (
  <div className={`${composeClassName('operator', isFirstInGroup, !!isLastInGroup)} typing-message`}>

    { messageViewType === 'bubble' && <AvatarImage {...{ messageViewType, imgParams, nickname }} /> }

    <div className="status">
      {
        messageViewType !== 'bubble'
        && <p className="author">{text}</p>
      }

      <p>
        <span className="circles">
          <span className="circle circle-1" />
          <span className="circle circle-2" />
          <span className="circle circle-3" />
        </span>
      </p>
    </div>
  </div>
);

export default TypingMessage
